import { TransactionSide } from '../constants'
import { TrackingEvent } from '../types/tracking'

type SellerProtectionScreenClickTarget =
  | 'seller_protection_information'
  | 'ship_with_peace_of_mind'
  | 'your_earnings_are_safe'
  | 'your_sales_covered'
  | 'quick_solutions_on_your_terms'
  | 'pack_the_item_well'

type SellerProtectionScreenClickEventArgs = {
  target: SellerProtectionScreenClickTarget
  screen?: string | null
  details?: string | null
  transactionId?: string | null
}

export const sellerProtectionScreenClickEvent = (
  args: SellerProtectionScreenClickEventArgs,
): TrackingEvent => {
  const { details, transactionId, screen, target } = args

  return {
    event: 'seller_protection_screen.click',
    extra: {
      screen,
      target,
      transaction_id: transactionId,
      details,
    },
  }
}

type SellerProtectionScreenViewEventArgs = {
  details?: string | null
  timeSpentInScreenMS: string
}

export const sellerProtectionScreenViewEvent = (
  args: SellerProtectionScreenViewEventArgs,
): TrackingEvent => {
  const { details, timeSpentInScreenMS } = args

  return {
    event: 'seller_protection_screen.view',
    extra: {
      screen: 'seller_protection_information',
      details,
      time_spent_in_screen_ms: timeSpentInScreenMS,
    },
  }
}

type OrderDetailsProtectionPoliciesClickTarget =
  | 'buyer_protection_learn_more'
  | 'seller_protection_learn_more'

type OrderDetailsProtectionPoliciesClickEventArgs = {
  target: OrderDetailsProtectionPoliciesClickTarget
  screen?: string | null
  details?: string | null
  transactionId?: string | null
  userSide: TransactionSide
}

export const orderDetailsProtectionPoliciesClickEvent = (
  args: OrderDetailsProtectionPoliciesClickEventArgs,
): TrackingEvent => {
  const { details, transactionId, screen, target, userSide } = args

  return {
    event: 'order_details_protection_policies.click',
    extra: {
      screen,
      target,
      transaction_id: transactionId,
      user_side: userSide,
      details,
    },
  }
}

type OrderDetailsItemImageClickEventArgs = {
  screen?: string | null
  details?: string | null
  transactionId: string | null
  itemId: string | null
  positionInList: number | null
  itemsInList: number | null
  userSide: TransactionSide
}

export const orderDetailsItemImageClickEvent = (
  args: OrderDetailsItemImageClickEventArgs,
): TrackingEvent => {
  const { details, transactionId, screen, userSide, itemId, positionInList, itemsInList } = args

  return {
    event: 'order_details_item_image.click',
    extra: {
      screen,
      transaction_id: transactionId,
      user_side: userSide,
      item_id: itemId,
      position_in_list: positionInList,
      items_in_list: itemsInList,
      details,
    },
  }
}
